import { initializeApp } from "https://www.gstatic.com/firebasejs/10.7.1/firebase-app.js";
import {
  getFirestore,
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "https://www.gstatic.com/firebasejs/10.7.1/firebase-firestore.js";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCQZJ0wXSLrH_HJrYG6ST6X6uEnj712tFE",
  authDomain: "recipies-d48e1.firebaseapp.com",
  databaseURL: "https://recipies-d48e1-default-rtdb.firebaseio.com",
  projectId: "recipies-d48e1",
  storageBucket: "recipies-d48e1.appspot.com",
  messagingSenderId: "135559238792",
  appId: "1:135559238792:web:b94a200985341d2d957b3d",
  measurementId: "G-JHX34WVLKS"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const db = getFirestore(app);

const reviewsRef = collection(db, "reviews");

const printReviews = async (reviewsRef, product_id) => {
  const q = query(reviewsRef, where("productId", "==", product_id));
  const querySnapshot = await getDocs(q);

  const reviews = [];
  querySnapshot.forEach((doc) => {
    reviews.push(doc.data());
  });

  return reviews;
};

let product_id = document.querySelector(
  "form.product-form input[name='product-id']"
).value;

// console.log("script running");

// ===================
const gstar =
  '<div class="rating-star"><svg viewBox="0 -0.5 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M16.0005 0L21.4392 9.27275L32.0005 11.5439L24.8005 19.5459L25.889 30.2222L16.0005 25.895L6.11194 30.2222L7.20049 19.5459L0.000488281 11.5439L10.5618 9.27275L16.0005 0Z" fill="#d1d1d1"></path> </g></svg></div>';
const ystar =
  '<div class="rating-star"><svg viewBox="0 -0.5 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M16.0005 0L21.4392 9.27275L32.0005 11.5439L24.8005 19.5459L25.889 30.2222L16.0005 25.895L6.11194 30.2222L7.20049 19.5459L0.000488281 11.5439L10.5618 9.27275L16.0005 0Z" fill="#f9d243"></path> </g></svg></div>';

let totalReviewRatio = 0.0;
let totalReviewRaw = 0.0;
let totalRevewCount = 0;

let fiveStarCount = 0;
let fourStarCount = 0;
let threeStarCount = 0;
let twoStarCount = 0;
let oneStarCount = 0;

function getReviewStars(rating) {
  const clampedRating = Math.min(Math.max(parseFloat(rating) || 0, 0), 5);
  const percentageFilled = (clampedRating / 5) * 100;

  let startsFilled = "";

  for (let index = 1; index <= 5; index++) {
    if (index <= rating) {
      startsFilled += `${ystar}`;
    } else {
      startsFilled += `${gstar}`;
    }
  }
  const ratingString = `
    <div class="star-rating">
        ${startsFilled}
    </div>
  `;

  return ratingString;
}

function get_reviews_percent(reviews, totalReviews){
    return Math.round((reviews/totalReviews) * 100);
}

function incrementStarcount(ratings){
  if(Math.round(ratings) == 5) {
    fiveStarCount++;
  }
  else if(Math.round(ratings) == 4) {
    fourStarCount++;
  }
  else if(Math.round(ratings) == 3) {
    threeStarCount++;
  }
  else if(Math.round(ratings) == 2) {
    twoStarCount++;
  }
  else if(Math.round(ratings) == 1) {
    oneStarCount++;
  }
}
let reviewsCont = document.querySelector("div.product-reviews-container");
// debugger;
let alreviews = await printReviews(reviewsRef, parseInt(product_id));
if (alreviews.length > 0) { 
  let reviewObj = alreviews[0].reviews;
  console.log(alreviews, product_id);
  
  const reviewTemplate = document.getElementById("product-single-review");
  const container = document.querySelector(".product-reviews-container");
  
  
  
  
  // Define an array of month names
  var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  
  
  let author_image = "";
  if(reviewObj.length > 0) {
    for (const review of reviewObj) {
      if(review.verified === true){
        const clone = document.importNode(reviewTemplate.content, true);
        totalRevewCount++;
        totalReviewRaw += review.rating;
        author_image = review.author_image ? review.author_image : "https://cdn.shopify.com/s/files/1/0675/1535/1347/files/empty-user.jpg?v=1706180666";
  console.log(totalReviewRaw);
        incrementStarcount(review.rating);
        // Replace placeholders with actual values
        clone.querySelector(".author-image img").src = author_image;
        clone.querySelector(".author-name").textContent = review.author_name;
        let reviewsGiven = getReviewStars(review.rating);
        clone.querySelector(".reviews-given").innerHTML = `${reviewsGiven}`;
        clone.querySelector(".author-message").innerHTML = `${review.message}`;
        if (review.Recommended) {
          clone.querySelector(".recommend_product").classList.remove("d-none");
        }
        
        if (review.createdAt) {
          var date = new Date(review.createdAt);
          // Format the date as "Month Day, Year"
          var formattedDate = months[date.getMonth()] + " " + date.getDate() + ", " + date.getFullYear();
          clone.querySelector(".review-date").innerHTML = formattedDate; // January 4, 2024
        }
        
        // Append the cloned template to the container
        container.appendChild(clone);
        
      }
    }
  }
}
if (totalReviewRaw != 0 && totalRevewCount != 0) {
  totalReviewRatio = totalReviewRaw / totalRevewCount;
} 
let trr = Math.round((totalReviewRatio + Number.EPSILON) * 100) / 100;
document.querySelector("#total-review-ratio").textContent = trr.toFixed(1);
document.querySelector("#total-review-count").textContent = totalRevewCount;
// debugger;

//setting totall review bars
//5
document.querySelector("#product-review-bar-5 .review-bar-bg").style.width = get_reviews_percent(fiveStarCount,totalReviewRaw)+"%"
document.querySelector("#product-review-bar-4 .review-bar-bg").style.width = get_reviews_percent(fourStarCount,totalReviewRaw)+"%"
document.querySelector("#product-review-bar-3 .review-bar-bg").style.width = get_reviews_percent(threeStarCount,totalReviewRaw)+"%"
document.querySelector("#product-review-bar-2 .review-bar-bg").style.width = get_reviews_percent(twoStarCount,totalReviewRaw)+"%"
document.querySelector("#product-review-bar-1 .review-bar-bg").style.width = get_reviews_percent(oneStarCount,totalReviewRaw)+"%"

document.querySelector("#product-review-count-num-5").textContent = fiveStarCount
document.querySelector("#product-review-count-num-4").textContent = fourStarCount
document.querySelector("#product-review-count-num-3").textContent = threeStarCount
document.querySelector("#product-review-count-num-2").textContent = twoStarCount
document.querySelector("#product-review-count-num-1").textContent = oneStarCount
// console.log(fiveStarCount, fourStarCount,threeStarCount, twoStarCount,oneStarCount)

jQuery(document).ready(function ($) {
  // debugger
  let rec_count = trr;
  console.log(rec_count)
  if(rec_count == 1){
      jQuery('.spr-icon[data-rate="1"]').removeClass("far fa-star").addClass("fa-solid fa-star");
  }else if(rec_count > 1 && rec_count < 2){
      jQuery('.spr-icon[data-rate="1"]').removeClass("far fa-star").addClass("fa-solid fa-star");
      jQuery('.spr-icon[data-rate="2"]').removeClass("far fa-star").addClass("fas fa-star-half-alt");
  }else if(rec_count == 2){
      jQuery('.spr-icon[data-rate="1"], .spr-icon[data-rate="2"]').removeClass("far fa-star").addClass("fa-solid fa-star");
  }else if(rec_count > 2 && rec_count < 3){
      jQuery('.spr-icon[data-rate="1"], .spr-icon[data-rate="2"]').removeClass("far fa-star").addClass("fa-solid fa-star");
      jQuery('.spr-icon[data-rate="3"]').removeClass("far fa-star").addClass("fas fa-star-half-alt");
  }else if(rec_count == 3){
      jQuery('.spr-icon[data-rate="1"], .spr-icon[data-rate="2"], .spr-icon[data-rate="3"]').removeClass("far fa-star").addClass("fa-solid fa-star");
  }else if(rec_count > 3 && rec_count < 4){
      jQuery('.spr-icon[data-rate="1"], .spr-icon[data-rate="2"], .spr-icon[data-rate="3"]').removeClass("far fa-star").addClass("fa-solid fa-star");
      jQuery('.spr-icon[data-rate="4"]').removeClass("far fa-star").addClass("fas fa-star-half-alt");
  }else if(rec_count == 4){
      jQuery('.spr-icon[data-rate="1"], .spr-icon[data-rate="2"], .spr-icon[data-rate="3"], .spr-icon[data-rate="4"]').removeClass("far fa-star").addClass("fa-solid fa-star");
  }else if(rec_count > 4 && rec_count < 5){
      jQuery('.spr-icon[data-rate="1"], .spr-icon[data-rate="2"], .spr-icon[data-rate="3"], .spr-icon[data-rate="4"]').removeClass("far fa-star").addClass("fa-solid fa-star");
      jQuery('.spr-icon[data-rate="5"]').removeClass("far fa-star").addClass("fas fa-star-half-alt");
  }else if(rec_count == 5){
      jQuery('.spr-icon[data-rate="1"], .spr-icon[data-rate="2"], .spr-icon[data-rate="3"], .spr-icon[data-rate="4"], .spr-icon[data-rate="5"]').removeClass("far fa-star").addClass("fa-solid fa-star");
  }
  
  if (totalRevewCount != 0) {
    jQuery(".spr-badge-caption span").text(trr.toFixed(1)+" / based on "+totalRevewCount)
  } else {
    jQuery(".spr-badge-caption span").text("No")
  }
  jQuery(".product-form__item.mjr label").text("Amount")

  jQuery("span.mjr-product-reviews-badge a").click(function (e) {
      e.preventDefault();
      $('html, body').animate({
          scrollTop: $($(this).attr('data-target')).offset().top - 200
      }, 2000);
  })
  var maxLength = 100; // set your desired character limit
    if ($('.author-message').length) {
      $('.author-message').each(function() {
          var content = $(this).text();
  
          if (content.length > maxLength) {
              var shortContent = content.substr(0, maxLength);
              var longContent = content.substr(maxLength);
  
              $(this).html(shortContent + '<span class="read-more">... <a href="#" class="read-more-link">Read More</a></span>');
              jQuery(this).after("<span class='full-con' style='display:none !important'>"+content+"</span>")
              $('.read-more-link').on('click', function(e) {
                  e.preventDefault();
                  $(this).closest('.author-message').html(content + '<span class="read-less">. <a href="#" class="read-less-link">Show Less</a></span>');
              });
          }
      });
    }

    $("body").on('click', 'a.read-less-link', function(e) {
      var longCon = $(this).parents(".product-single-review").find("span.full-con").text()

      // var longCon = $(this).text();
  
      if (longCon.length > maxLength) {
          var shortContent = longCon.substr(0, maxLength);
          var longContent = longCon.substr(maxLength);

          $(this).closest('.author-message').html(shortContent + '<span class="read-more">... <a href="#" class="read-more-link">Read More</a></span>');
          $('.read-more-link').on('click', function(e) {
              e.preventDefault();
              $(this).closest('.author-message').html(longCon + '<span class="read-less">. <a href="#" class="read-less-link">Show Less</a></span>');
          });
      }

      
    })


  
})// end doc
